import type { TFunction } from "i18next";
import { FrameworkAgreementType, type EventValueDto } from "../../../../autogen/bff-api";
import { displaySum } from "../../../../common/formatting/displaySum";
import { frameworkMechanismLabel } from "../../../../common/procurement/publicProcurementOptions";

export interface FrameworkCompetitionTerms {
  frameworkAgreement?: FrameworkAgreementType | null;
  frameworkMaxParticipants?: number | null;
  frameworkMaximumValue?: EventValueDto | null;
}

export const frameworkCompetitionRows = (
  terms: FrameworkCompetitionTerms,
  t: TFunction,
): { label: string; value: string }[] => {
  const mechanism = terms.frameworkAgreement;
  if (!mechanism || mechanism === FrameworkAgreementType.None) return [];
  const maximum = terms.frameworkMaximumValue;
  return [
    { label: t("Framework agreement"), value: t("Yes") },
    { label: t("Call-off mechanism"), value: frameworkMechanismLabel(mechanism, t) },
    terms.frameworkMaxParticipants != null && {
      label: t("Maximum number of suppliers"),
      value: String(terms.frameworkMaxParticipants),
    },
    maximum?.value != null && {
      label: t("Maximum value"),
      value: displaySum({ value: maximum.value, currency: maximum.currency }),
    },
  ].filter((row): row is { label: string; value: string } => Boolean(row));
};
